import RightSidebarNotes from './RightSidebarNotest';

export default RightSidebarNotes;
